import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bar, Icon, Ring, Segmented, TypeBadge, MobileHeader, EmptyState, QueryState, ListSkeleton } from '@/components';
import { useCourses, useEnrollments } from '@/hooks/queries';
import { useLocalized } from '@/hooks/useLocalized';
import { metCount } from '@/lib/requirements';

export function MobileMyCourses() {
  const navigate = useNavigate();
  const { L } = useLocalized();
  const coursesQuery = useCourses();
  const { data: enrollments = [] } = useEnrollments();
  const [tab, setTab] = useState<'active' | 'done'>('active');

  const enrolled = (coursesQuery.data ?? []).filter((c) => enrollments.some((e) => e.courseId === c.id));

  return (
    <div style={{ background: 'var(--paper)', minHeight: '100%' }}>
      <MobileHeader title="Learning" th="การเรียนของฉัน" />
      <div style={{ padding: '14px 20px 4px' }}>
        <Segmented
          value={tab}
          onChange={setTab}
          options={[
            { value: 'active', label: `In progress · ${enrolled.length}` },
            { value: 'done', label: 'Completed · 0' },
          ]}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, padding: '14px 20px 28px' }}>
        {tab === 'active' && (
          <QueryState query={coursesQuery} skeleton={<ListSkeleton rows={3} />} isEmpty={() => enrolled.length === 0} emptyIcon="stack" emptyTitle="No courses yet" emptyHint="Browse the catalog to enrol." emptyAction={<button className="btn btn-primary btn-sm" onClick={() => navigate('/learn/catalog')}>Browse catalog</button>}>
            {() => (
              <>
                {enrolled.map((c) => {
                  const e = enrollments.find((x) => x.courseId === c.id)!;
                  const met = metCount(c, e);
                  return (
                    <button key={c.id} onClick={() => navigate(`/learn/learning/${c.id}`)} style={{ all: 'unset', cursor: 'pointer', display: 'block' }}>
                      <div className="card" style={{ padding: 16 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 13 }}>
                          <div style={{ width: 46, height: 46, borderRadius: 11, background: c.logoUrl ? `${c.cover} center/contain no-repeat url("${c.logoUrl}")` : c.cover, flex: 'none', border: '1px solid var(--line)' }} />
                          <div style={{ minWidth: 0, flex: 1 }}>
                            <div className="th" style={{ fontSize: 15.5, fontWeight: 600, lineHeight: 1.3 }}>{L(c.title)}</div>
                            <div style={{ fontSize: 12.5, color: 'var(--ink-3)', marginTop: 2 }}>{c.title.en}</div>
                          </div>
                          <Ring value={e.progress} size={42} stroke={4} label={false} />
                        </div>
                        <Bar value={e.progress} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
                          <TypeBadge type={c.type} />
                          <span style={{ fontSize: 12.5, color: 'var(--ink-3)', display: 'flex', gap: 6, alignItems: 'center' }}>
                            <Icon name="checkCircle" size={14} style={{ color: 'var(--sage)' }} /> {met}/{c.requirements.length} requirements
                          </span>
                        </div>
                      </div>
                    </button>
                  );
                })}
              </>
            )}
          </QueryState>
        )}
        {tab === 'done' && (
          <EmptyState icon="award" title="No completed courses yet" hint="Finish a course to earn your first certificate." />
        )}
      </div>
    </div>
  );
}
